'use strict';

var SoaCollection = require('bunsen/collections/SoaCollection');
var endpoints = require('dibs-endpoints');
var PortfolioModel = require('bunsen/models/portfolio/PortfolioModel');

module.exports = SoaCollection.extend({
    url : endpoints.portfolios(),
    model: PortfolioModel,
    initialize: function (options) {
        this.options = options || {};
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/portfolio/PortfolioCollection.js
// module id = 863
// module chunks = 63